// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: analysis_plan.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ColumnHashProto, ColumnValuesProto, DataValueProto, ObservationDataProto } from "./data";
import {
  AnalysisColumnType,
  analysisColumnTypeFromJSON,
  analysisColumnTypeToJSON,
  OutcomeMixture,
  outcomeMixtureFromJSON,
  outcomeMixtureToJSON,
} from "./enums";
import { BenchmarkEntityProto } from "./knowledege_graph";
import {
  ErrorDetailProto,
  FilterProto,
  Header,
  MetricEdgeProto,
  MetricProto,
  ObservationColumnProto,
  ObservationProto,
} from "./metadata";

export const protobufPackage = "com.meritic.newton";

/** Type of selection to use for recommendation. */
export enum SelectionType {
  /** NONE - Select none of the rows. */
  NONE = 0,
  /** ALL - Select all the rows. */
  ALL = 1,
  /** SPECIFIC_VALUES - Select specific values. */
  SPECIFIC_VALUES = 2,
  /** TOP_N_PERCENT - Select Top-N% of the values. */
  TOP_N_PERCENT = 3,
  /** BOTTOM_N_PERCENT - Select Bottom-N% of the values. */
  BOTTOM_N_PERCENT = 4,
  /** SELECT_ALL_ROWS - Select all rows. */
  SELECT_ALL_ROWS = 5,
  /** SELECT_ATTR_VALUES - Select specific attribute values for given attribute column */
  SELECT_ATTR_VALUES = 6,
  /** SELECT_METRIC_MEASURES - Select metric and measure columns */
  SELECT_METRIC_MEASURES = 7,
  UNRECOGNIZED = -1,
}

export function selectionTypeFromJSON(object: any): SelectionType {
  switch (object) {
    case 0:
    case "NONE":
      return SelectionType.NONE;
    case 1:
    case "ALL":
      return SelectionType.ALL;
    case 2:
    case "SPECIFIC_VALUES":
      return SelectionType.SPECIFIC_VALUES;
    case 3:
    case "TOP_N_PERCENT":
      return SelectionType.TOP_N_PERCENT;
    case 4:
    case "BOTTOM_N_PERCENT":
      return SelectionType.BOTTOM_N_PERCENT;
    case 5:
    case "SELECT_ALL_ROWS":
      return SelectionType.SELECT_ALL_ROWS;
    case 6:
    case "SELECT_ATTR_VALUES":
      return SelectionType.SELECT_ATTR_VALUES;
    case 7:
    case "SELECT_METRIC_MEASURES":
      return SelectionType.SELECT_METRIC_MEASURES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SelectionType.UNRECOGNIZED;
  }
}

export function selectionTypeToJSON(object: SelectionType): string {
  switch (object) {
    case SelectionType.NONE:
      return "NONE";
    case SelectionType.ALL:
      return "ALL";
    case SelectionType.SPECIFIC_VALUES:
      return "SPECIFIC_VALUES";
    case SelectionType.TOP_N_PERCENT:
      return "TOP_N_PERCENT";
    case SelectionType.BOTTOM_N_PERCENT:
      return "BOTTOM_N_PERCENT";
    case SelectionType.SELECT_ALL_ROWS:
      return "SELECT_ALL_ROWS";
    case SelectionType.SELECT_ATTR_VALUES:
      return "SELECT_ATTR_VALUES";
    case SelectionType.SELECT_METRIC_MEASURES:
      return "SELECT_METRIC_MEASURES";
    case SelectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of observation edits. */
export enum ObservationEditType {
  ADD_FILTER = 0,
  REMOVE_FILTER = 1,
  REPLACE_FILTER = 2,
  ADD_COLUMN = 3,
  REMOVE_COLUMN = 4,
  REPLACE_COLUMN = 5,
  ADD_BENCHMARK = 6,
  REMOVE_BENCHMARK = 7,
  ADD_METRIC = 8,
  REMOVE_METRIC = 9,
  UNRECOGNIZED = -1,
}

export function observationEditTypeFromJSON(object: any): ObservationEditType {
  switch (object) {
    case 0:
    case "ADD_FILTER":
      return ObservationEditType.ADD_FILTER;
    case 1:
    case "REMOVE_FILTER":
      return ObservationEditType.REMOVE_FILTER;
    case 2:
    case "REPLACE_FILTER":
      return ObservationEditType.REPLACE_FILTER;
    case 3:
    case "ADD_COLUMN":
      return ObservationEditType.ADD_COLUMN;
    case 4:
    case "REMOVE_COLUMN":
      return ObservationEditType.REMOVE_COLUMN;
    case 5:
    case "REPLACE_COLUMN":
      return ObservationEditType.REPLACE_COLUMN;
    case 6:
    case "ADD_BENCHMARK":
      return ObservationEditType.ADD_BENCHMARK;
    case 7:
    case "REMOVE_BENCHMARK":
      return ObservationEditType.REMOVE_BENCHMARK;
    case 8:
    case "ADD_METRIC":
      return ObservationEditType.ADD_METRIC;
    case 9:
    case "REMOVE_METRIC":
      return ObservationEditType.REMOVE_METRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ObservationEditType.UNRECOGNIZED;
  }
}

export function observationEditTypeToJSON(object: ObservationEditType): string {
  switch (object) {
    case ObservationEditType.ADD_FILTER:
      return "ADD_FILTER";
    case ObservationEditType.REMOVE_FILTER:
      return "REMOVE_FILTER";
    case ObservationEditType.REPLACE_FILTER:
      return "REPLACE_FILTER";
    case ObservationEditType.ADD_COLUMN:
      return "ADD_COLUMN";
    case ObservationEditType.REMOVE_COLUMN:
      return "REMOVE_COLUMN";
    case ObservationEditType.REPLACE_COLUMN:
      return "REPLACE_COLUMN";
    case ObservationEditType.ADD_BENCHMARK:
      return "ADD_BENCHMARK";
    case ObservationEditType.REMOVE_BENCHMARK:
      return "REMOVE_BENCHMARK";
    case ObservationEditType.ADD_METRIC:
      return "ADD_METRIC";
    case ObservationEditType.REMOVE_METRIC:
      return "REMOVE_METRIC";
    case ObservationEditType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Rules to capture the results for diagnostic analysis. */
export interface DiagnosticResultRules {
  /** If all actual and benchmark values are less than this, then ignore the result. */
  ignore_max_values?:
    | number
    | undefined;
  /** If variance % from any benchmark is less than this, then its broken. */
  broken_max_var_percent?:
    | number
    | undefined;
  /** If variance % from all benchmarks is more than this, then its thriving. */
  thriving_min_var_percent?: number | undefined;
}

/** Represents the complete Analysis Plan */
export interface AnalysisPlanProto {
  /** Header containing metadata about the analysis plan */
  header?:
    | Header
    | undefined;
  /** The metric for which analysis is planned */
  metric?:
    | MetricProto
    | undefined;
  /** Additional context/filters for analysis */
  additional_context: ObservationEditProto[];
  /** MKG edges for root step analysis */
  mkg_edges: MetricEdgeProto[];
  /** Id of the root step. */
  root_step_id?:
    | string
    | undefined;
  /** Root kg observation for the analysis plan. */
  root_observation?:
    | KGObservationProto
    | undefined;
  /** Analysis Steps. */
  analysis_steps: AnalysisStepProto[];
  /** Plan specific questions. */
  questions: string[];
}

/** Represents a single step in the analysis */
export interface AnalysisStepProto {
  /** Step id. */
  id?:
    | string
    | undefined;
  /** Step label. */
  step_label?:
    | string
    | undefined;
  /** Observation for this step */
  observation_edits: ObservationEditProto[];
  /** MKG edges for analysis */
  edges: MetricEdgeProto[];
  /** Column calculations for this step */
  column_calculations: AnalysisColumnCalculationProto[];
  /** Column hashes to calculate analysis columns. */
  analysis_columns: ColumnHashProto[];
  /** Rules for generating recommendations */
  recommendation_rules: RecommendationRuleProto[];
}

/** Observation edits. */
export interface ObservationEditProto {
  edit_type?: ObservationEditType | undefined;
  is_recommendation?:
    | boolean
    | undefined;
  /** One of the following will be set. */
  filter?: FilterProto | undefined;
  column?: ObservationColumnProto | undefined;
  metric?: MetricProto | undefined;
  benchmark?: BenchmarkEntityProto | undefined;
  add_filter?: FilterProto | undefined;
  remove_filter?: FilterProto | undefined;
  replace_filter?: FilterProto | undefined;
  add_column?: ObservationColumnProto | undefined;
  remove_column?: ObservationColumnProto | undefined;
  replace_column?: ObservationColumnProto | undefined;
}

/** Defines how analysis columns should be calculated */
export interface AnalysisColumnCalculationProto {
  /** Maps column IDs to their types */
  analysis_columns_map: AnalysisColumnCalculationProto_AnalysisColumnsMap[];
  /** Reference column IDs used in calculations */
  reference_column_ids: string[];
  /** Optional diagnostic configuration */
  diagnostic_rules?: DiagnosticResultRules | undefined;
}

export interface AnalysisColumnCalculationProto_AnalysisColumnsMap {
  column_id?: string | undefined;
  column_type?: AnalysisColumnType | undefined;
}

/** Rules for generating recommendations */
export interface RecommendationRuleProto {
  /** Criteria for selecting rows */
  selections: SelectionCriteriaProto[];
  /** Steps to execute for selected rows */
  child_step_ids: string[];
}

/** Criteria for selecting rows for recommendations */
export interface SelectionCriteriaProto {
  type?:
    | SelectionType
    | undefined;
  /** Map of attribute values for specific attribute values selection. */
  attribute_values_map: SelectionCriteriaProto_AttributeValues[];
  /** list of column hashes of selected column for top / bottom n calculation. */
  criteria_columns: ColumnHashProto[];
  /** Column ID to apply criteria on */
  criteria_column_id?:
    | string
    | undefined;
  /** Specific values for SPECIFIC_VALUES type */
  specific_values: string[];
  /** Specific values for subset rows. */
  rows_subset?:
    | SelectionCriteriaProto_RowsSubset
    | undefined;
  /** Threshold for TOP_N_PERCENT/BOTTOM_N_PERCENT types */
  threshold?: number | undefined;
}

export interface SelectionCriteriaProto_AttributeValues {
  /** Id of attribute column. */
  column_id?:
    | string
    | undefined;
  /** Values to select for this column. */
  values: string[];
}

export interface SelectionCriteriaProto_RowsSubset {
  /** Reference column id. */
  reference_id?:
    | string
    | undefined;
  /** Reference column values. */
  row_values: string[];
}

/** Represents a key-value pair for data results */
export interface DataResultRowProto {
  row_index?: number | undefined;
  column_values: DataResultRowProto_ColumnValue[];
}

/** Represents a key-value pair for row values */
export interface DataResultRowProto_ColumnValue {
  column_id?: string | undefined;
  value?: DataValueProto | undefined;
}

/** Represents the results of analysis for a tree node */
export interface NodeResultProto {
  /** Map of Data rows keyed by row index which is picked */
  data_results: DataResultRowProto[];
  /** Outcome mixture for the node data */
  mixture_profile?:
    | OutcomeMixture
    | undefined;
  /** Total number of rows in node data */
  num_rows?:
    | number
    | undefined;
  /** Error messages causing node failure */
  node_failures: string[];
  /** error details causing node failures. */
  error_details: ErrorDetailProto[];
}

/** Representation of each node in the analysis tree. */
export interface TreeNodeProto {
  /** Id of the node. */
  id?:
    | string
    | undefined;
  /** Observation on which analysis is done. */
  observation?:
    | ObservationProto
    | undefined;
  /** Depth of the node in the analysis tree. */
  node_depth?:
    | number
    | undefined;
  /** Node metric. */
  metric?:
    | MetricProto
    | undefined;
  /** Edges analyzed on this node. */
  edges: MetricEdgeProto[];
  /** Analysed data after the analysis in this node is done. */
  analysed_data?:
    | ObservationDataProto
    | undefined;
  /** Results of the analysis. */
  analysis_result?:
    | NodeResultProto
    | undefined;
  /** Ids of the child nodes in the analysis tree. */
  children_ids: string[];
  parent_reference?: TreeNodeProto_ParentReference | undefined;
}

/** Reference to parent node id and row index */
export interface TreeNodeProto_ParentReference {
  parent_id?: string | undefined;
  row_index?: number | undefined;
}

/** Representation of KGObservation. */
export interface KGObservationProto {
  metrics: MetricProto[];
  benchmarks: BenchmarkEntityProto[];
  columns: ObservationColumnProto[];
  filters: FilterProto[];
  skipped_metric_ids: string[];
  calculate_non_measure_only?: boolean | undefined;
  benchmark_columns: ColumnHashProto[];
  analysis_columns: ColumnHashProto[];
}

/** Representation of KGObservationData */
export interface KGObservationDataProto {
  kg_observation?: KGObservationProto | undefined;
  actuals: ColumnValuesProto[];
  benchmark_values: ColumnValuesProto[];
  non_measure_values: ColumnValuesProto[];
  analysis_columns: ColumnValuesProto[];
  material_columns: ColumnValuesProto[];
  missing_columns: ColumnHashProto[];
}

/** Proto representation of recommendation edit. */
export interface RecommendationProto {
  /** Recommendation id. */
  id?:
    | string
    | undefined;
  /** list of observation edits used to generate the child node. */
  edits: ObservationEditProto[];
  /** subset of kg observation data used to generate the child node. */
  recommended_data: ColumnValuesProto[];
  /** anyone of these ids will be used to generate the child node. only set for dummy edits. */
  select_anyone: string[];
  /** Kg observation of the parent node. */
  parent_kg_observation?: KGObservationProto | undefined;
}

function createBaseDiagnosticResultRules(): DiagnosticResultRules {
  return { ignore_max_values: undefined, broken_max_var_percent: undefined, thriving_min_var_percent: undefined };
}

export const DiagnosticResultRules: MessageFns<DiagnosticResultRules> = {
  encode(message: DiagnosticResultRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ignore_max_values !== undefined) {
      writer.uint32(9).double(message.ignore_max_values);
    }
    if (message.broken_max_var_percent !== undefined) {
      writer.uint32(17).double(message.broken_max_var_percent);
    }
    if (message.thriving_min_var_percent !== undefined) {
      writer.uint32(25).double(message.thriving_min_var_percent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DiagnosticResultRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiagnosticResultRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.ignore_max_values = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.broken_max_var_percent = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.thriving_min_var_percent = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiagnosticResultRules {
    return {
      ignore_max_values: isSet(object.ignore_max_values) ? globalThis.Number(object.ignore_max_values) : undefined,
      broken_max_var_percent: isSet(object.broken_max_var_percent)
        ? globalThis.Number(object.broken_max_var_percent)
        : undefined,
      thriving_min_var_percent: isSet(object.thriving_min_var_percent)
        ? globalThis.Number(object.thriving_min_var_percent)
        : undefined,
    };
  },

  toJSON(message: DiagnosticResultRules): unknown {
    const obj: any = {};
    if (message.ignore_max_values !== undefined) {
      obj.ignore_max_values = message.ignore_max_values;
    }
    if (message.broken_max_var_percent !== undefined) {
      obj.broken_max_var_percent = message.broken_max_var_percent;
    }
    if (message.thriving_min_var_percent !== undefined) {
      obj.thriving_min_var_percent = message.thriving_min_var_percent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiagnosticResultRules>, I>>(base?: I): DiagnosticResultRules {
    return DiagnosticResultRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiagnosticResultRules>, I>>(object: I): DiagnosticResultRules {
    const message = createBaseDiagnosticResultRules();
    message.ignore_max_values = object.ignore_max_values ?? undefined;
    message.broken_max_var_percent = object.broken_max_var_percent ?? undefined;
    message.thriving_min_var_percent = object.thriving_min_var_percent ?? undefined;
    return message;
  },
};

function createBaseAnalysisPlanProto(): AnalysisPlanProto {
  return {
    header: undefined,
    metric: undefined,
    additional_context: [],
    mkg_edges: [],
    root_step_id: undefined,
    root_observation: undefined,
    analysis_steps: [],
    questions: [],
  };
}

export const AnalysisPlanProto: MessageFns<AnalysisPlanProto> = {
  encode(message: AnalysisPlanProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.metric !== undefined) {
      MetricProto.encode(message.metric, writer.uint32(18).fork()).join();
    }
    for (const v of message.additional_context) {
      ObservationEditProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.mkg_edges) {
      MetricEdgeProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.root_step_id !== undefined) {
      writer.uint32(42).string(message.root_step_id);
    }
    if (message.root_observation !== undefined) {
      KGObservationProto.encode(message.root_observation, writer.uint32(50).fork()).join();
    }
    for (const v of message.analysis_steps) {
      AnalysisStepProto.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.questions) {
      writer.uint32(66).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisPlanProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisPlanProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metric = MetricProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.additional_context.push(ObservationEditProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mkg_edges.push(MetricEdgeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.root_step_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.root_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.analysis_steps.push(AnalysisStepProto.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.questions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisPlanProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      metric: isSet(object.metric) ? MetricProto.fromJSON(object.metric) : undefined,
      additional_context: globalThis.Array.isArray(object?.additional_context)
        ? object.additional_context.map((e: any) => ObservationEditProto.fromJSON(e))
        : [],
      mkg_edges: globalThis.Array.isArray(object?.mkg_edges)
        ? object.mkg_edges.map((e: any) => MetricEdgeProto.fromJSON(e))
        : [],
      root_step_id: isSet(object.root_step_id) ? globalThis.String(object.root_step_id) : undefined,
      root_observation: isSet(object.root_observation)
        ? KGObservationProto.fromJSON(object.root_observation)
        : undefined,
      analysis_steps: globalThis.Array.isArray(object?.analysis_steps)
        ? object.analysis_steps.map((e: any) => AnalysisStepProto.fromJSON(e))
        : [],
      questions: globalThis.Array.isArray(object?.questions)
        ? object.questions.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AnalysisPlanProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.metric !== undefined) {
      obj.metric = MetricProto.toJSON(message.metric);
    }
    if (message.additional_context?.length) {
      obj.additional_context = message.additional_context.map((e) => ObservationEditProto.toJSON(e));
    }
    if (message.mkg_edges?.length) {
      obj.mkg_edges = message.mkg_edges.map((e) => MetricEdgeProto.toJSON(e));
    }
    if (message.root_step_id !== undefined) {
      obj.root_step_id = message.root_step_id;
    }
    if (message.root_observation !== undefined) {
      obj.root_observation = KGObservationProto.toJSON(message.root_observation);
    }
    if (message.analysis_steps?.length) {
      obj.analysis_steps = message.analysis_steps.map((e) => AnalysisStepProto.toJSON(e));
    }
    if (message.questions?.length) {
      obj.questions = message.questions;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisPlanProto>, I>>(base?: I): AnalysisPlanProto {
    return AnalysisPlanProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisPlanProto>, I>>(object: I): AnalysisPlanProto {
    const message = createBaseAnalysisPlanProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.metric = (object.metric !== undefined && object.metric !== null)
      ? MetricProto.fromPartial(object.metric)
      : undefined;
    message.additional_context = object.additional_context?.map((e) => ObservationEditProto.fromPartial(e)) || [];
    message.mkg_edges = object.mkg_edges?.map((e) => MetricEdgeProto.fromPartial(e)) || [];
    message.root_step_id = object.root_step_id ?? undefined;
    message.root_observation = (object.root_observation !== undefined && object.root_observation !== null)
      ? KGObservationProto.fromPartial(object.root_observation)
      : undefined;
    message.analysis_steps = object.analysis_steps?.map((e) => AnalysisStepProto.fromPartial(e)) || [];
    message.questions = object.questions?.map((e) => e) || [];
    return message;
  },
};

function createBaseAnalysisStepProto(): AnalysisStepProto {
  return {
    id: undefined,
    step_label: undefined,
    observation_edits: [],
    edges: [],
    column_calculations: [],
    analysis_columns: [],
    recommendation_rules: [],
  };
}

export const AnalysisStepProto: MessageFns<AnalysisStepProto> = {
  encode(message: AnalysisStepProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.step_label !== undefined) {
      writer.uint32(18).string(message.step_label);
    }
    for (const v of message.observation_edits) {
      ObservationEditProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.edges) {
      MetricEdgeProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.column_calculations) {
      AnalysisColumnCalculationProto.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.analysis_columns) {
      ColumnHashProto.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.recommendation_rules) {
      RecommendationRuleProto.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisStepProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisStepProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.step_label = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.observation_edits.push(ObservationEditProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.edges.push(MetricEdgeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.column_calculations.push(AnalysisColumnCalculationProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.analysis_columns.push(ColumnHashProto.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.recommendation_rules.push(RecommendationRuleProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisStepProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      step_label: isSet(object.step_label) ? globalThis.String(object.step_label) : undefined,
      observation_edits: globalThis.Array.isArray(object?.observation_edits)
        ? object.observation_edits.map((e: any) => ObservationEditProto.fromJSON(e))
        : [],
      edges: globalThis.Array.isArray(object?.edges) ? object.edges.map((e: any) => MetricEdgeProto.fromJSON(e)) : [],
      column_calculations: globalThis.Array.isArray(object?.column_calculations)
        ? object.column_calculations.map((e: any) => AnalysisColumnCalculationProto.fromJSON(e))
        : [],
      analysis_columns: globalThis.Array.isArray(object?.analysis_columns)
        ? object.analysis_columns.map((e: any) => ColumnHashProto.fromJSON(e))
        : [],
      recommendation_rules: globalThis.Array.isArray(object?.recommendation_rules)
        ? object.recommendation_rules.map((e: any) => RecommendationRuleProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AnalysisStepProto): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.step_label !== undefined) {
      obj.step_label = message.step_label;
    }
    if (message.observation_edits?.length) {
      obj.observation_edits = message.observation_edits.map((e) => ObservationEditProto.toJSON(e));
    }
    if (message.edges?.length) {
      obj.edges = message.edges.map((e) => MetricEdgeProto.toJSON(e));
    }
    if (message.column_calculations?.length) {
      obj.column_calculations = message.column_calculations.map((e) => AnalysisColumnCalculationProto.toJSON(e));
    }
    if (message.analysis_columns?.length) {
      obj.analysis_columns = message.analysis_columns.map((e) => ColumnHashProto.toJSON(e));
    }
    if (message.recommendation_rules?.length) {
      obj.recommendation_rules = message.recommendation_rules.map((e) => RecommendationRuleProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisStepProto>, I>>(base?: I): AnalysisStepProto {
    return AnalysisStepProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisStepProto>, I>>(object: I): AnalysisStepProto {
    const message = createBaseAnalysisStepProto();
    message.id = object.id ?? undefined;
    message.step_label = object.step_label ?? undefined;
    message.observation_edits = object.observation_edits?.map((e) => ObservationEditProto.fromPartial(e)) || [];
    message.edges = object.edges?.map((e) => MetricEdgeProto.fromPartial(e)) || [];
    message.column_calculations =
      object.column_calculations?.map((e) => AnalysisColumnCalculationProto.fromPartial(e)) || [];
    message.analysis_columns = object.analysis_columns?.map((e) => ColumnHashProto.fromPartial(e)) || [];
    message.recommendation_rules = object.recommendation_rules?.map((e) => RecommendationRuleProto.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseObservationEditProto(): ObservationEditProto {
  return {
    edit_type: undefined,
    is_recommendation: undefined,
    filter: undefined,
    column: undefined,
    metric: undefined,
    benchmark: undefined,
    add_filter: undefined,
    remove_filter: undefined,
    replace_filter: undefined,
    add_column: undefined,
    remove_column: undefined,
    replace_column: undefined,
  };
}

export const ObservationEditProto: MessageFns<ObservationEditProto> = {
  encode(message: ObservationEditProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.edit_type !== undefined) {
      writer.uint32(8).int32(message.edit_type);
    }
    if (message.is_recommendation !== undefined) {
      writer.uint32(16).bool(message.is_recommendation);
    }
    if (message.filter !== undefined) {
      FilterProto.encode(message.filter, writer.uint32(26).fork()).join();
    }
    if (message.column !== undefined) {
      ObservationColumnProto.encode(message.column, writer.uint32(34).fork()).join();
    }
    if (message.metric !== undefined) {
      MetricProto.encode(message.metric, writer.uint32(42).fork()).join();
    }
    if (message.benchmark !== undefined) {
      BenchmarkEntityProto.encode(message.benchmark, writer.uint32(50).fork()).join();
    }
    if (message.add_filter !== undefined) {
      FilterProto.encode(message.add_filter, writer.uint32(58).fork()).join();
    }
    if (message.remove_filter !== undefined) {
      FilterProto.encode(message.remove_filter, writer.uint32(66).fork()).join();
    }
    if (message.replace_filter !== undefined) {
      FilterProto.encode(message.replace_filter, writer.uint32(74).fork()).join();
    }
    if (message.add_column !== undefined) {
      ObservationColumnProto.encode(message.add_column, writer.uint32(82).fork()).join();
    }
    if (message.remove_column !== undefined) {
      ObservationColumnProto.encode(message.remove_column, writer.uint32(90).fork()).join();
    }
    if (message.replace_column !== undefined) {
      ObservationColumnProto.encode(message.replace_column, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObservationEditProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObservationEditProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.edit_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.is_recommendation = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.filter = FilterProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.column = ObservationColumnProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.metric = MetricProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.benchmark = BenchmarkEntityProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.add_filter = FilterProto.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.remove_filter = FilterProto.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.replace_filter = FilterProto.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.add_column = ObservationColumnProto.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.remove_column = ObservationColumnProto.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.replace_column = ObservationColumnProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObservationEditProto {
    return {
      edit_type: isSet(object.edit_type) ? observationEditTypeFromJSON(object.edit_type) : undefined,
      is_recommendation: isSet(object.is_recommendation) ? globalThis.Boolean(object.is_recommendation) : undefined,
      filter: isSet(object.filter) ? FilterProto.fromJSON(object.filter) : undefined,
      column: isSet(object.column) ? ObservationColumnProto.fromJSON(object.column) : undefined,
      metric: isSet(object.metric) ? MetricProto.fromJSON(object.metric) : undefined,
      benchmark: isSet(object.benchmark) ? BenchmarkEntityProto.fromJSON(object.benchmark) : undefined,
      add_filter: isSet(object.add_filter) ? FilterProto.fromJSON(object.add_filter) : undefined,
      remove_filter: isSet(object.remove_filter) ? FilterProto.fromJSON(object.remove_filter) : undefined,
      replace_filter: isSet(object.replace_filter) ? FilterProto.fromJSON(object.replace_filter) : undefined,
      add_column: isSet(object.add_column) ? ObservationColumnProto.fromJSON(object.add_column) : undefined,
      remove_column: isSet(object.remove_column) ? ObservationColumnProto.fromJSON(object.remove_column) : undefined,
      replace_column: isSet(object.replace_column) ? ObservationColumnProto.fromJSON(object.replace_column) : undefined,
    };
  },

  toJSON(message: ObservationEditProto): unknown {
    const obj: any = {};
    if (message.edit_type !== undefined) {
      obj.edit_type = observationEditTypeToJSON(message.edit_type);
    }
    if (message.is_recommendation !== undefined) {
      obj.is_recommendation = message.is_recommendation;
    }
    if (message.filter !== undefined) {
      obj.filter = FilterProto.toJSON(message.filter);
    }
    if (message.column !== undefined) {
      obj.column = ObservationColumnProto.toJSON(message.column);
    }
    if (message.metric !== undefined) {
      obj.metric = MetricProto.toJSON(message.metric);
    }
    if (message.benchmark !== undefined) {
      obj.benchmark = BenchmarkEntityProto.toJSON(message.benchmark);
    }
    if (message.add_filter !== undefined) {
      obj.add_filter = FilterProto.toJSON(message.add_filter);
    }
    if (message.remove_filter !== undefined) {
      obj.remove_filter = FilterProto.toJSON(message.remove_filter);
    }
    if (message.replace_filter !== undefined) {
      obj.replace_filter = FilterProto.toJSON(message.replace_filter);
    }
    if (message.add_column !== undefined) {
      obj.add_column = ObservationColumnProto.toJSON(message.add_column);
    }
    if (message.remove_column !== undefined) {
      obj.remove_column = ObservationColumnProto.toJSON(message.remove_column);
    }
    if (message.replace_column !== undefined) {
      obj.replace_column = ObservationColumnProto.toJSON(message.replace_column);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObservationEditProto>, I>>(base?: I): ObservationEditProto {
    return ObservationEditProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObservationEditProto>, I>>(object: I): ObservationEditProto {
    const message = createBaseObservationEditProto();
    message.edit_type = object.edit_type ?? undefined;
    message.is_recommendation = object.is_recommendation ?? undefined;
    message.filter = (object.filter !== undefined && object.filter !== null)
      ? FilterProto.fromPartial(object.filter)
      : undefined;
    message.column = (object.column !== undefined && object.column !== null)
      ? ObservationColumnProto.fromPartial(object.column)
      : undefined;
    message.metric = (object.metric !== undefined && object.metric !== null)
      ? MetricProto.fromPartial(object.metric)
      : undefined;
    message.benchmark = (object.benchmark !== undefined && object.benchmark !== null)
      ? BenchmarkEntityProto.fromPartial(object.benchmark)
      : undefined;
    message.add_filter = (object.add_filter !== undefined && object.add_filter !== null)
      ? FilterProto.fromPartial(object.add_filter)
      : undefined;
    message.remove_filter = (object.remove_filter !== undefined && object.remove_filter !== null)
      ? FilterProto.fromPartial(object.remove_filter)
      : undefined;
    message.replace_filter = (object.replace_filter !== undefined && object.replace_filter !== null)
      ? FilterProto.fromPartial(object.replace_filter)
      : undefined;
    message.add_column = (object.add_column !== undefined && object.add_column !== null)
      ? ObservationColumnProto.fromPartial(object.add_column)
      : undefined;
    message.remove_column = (object.remove_column !== undefined && object.remove_column !== null)
      ? ObservationColumnProto.fromPartial(object.remove_column)
      : undefined;
    message.replace_column = (object.replace_column !== undefined && object.replace_column !== null)
      ? ObservationColumnProto.fromPartial(object.replace_column)
      : undefined;
    return message;
  },
};

function createBaseAnalysisColumnCalculationProto(): AnalysisColumnCalculationProto {
  return { analysis_columns_map: [], reference_column_ids: [], diagnostic_rules: undefined };
}

export const AnalysisColumnCalculationProto: MessageFns<AnalysisColumnCalculationProto> = {
  encode(message: AnalysisColumnCalculationProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.analysis_columns_map) {
      AnalysisColumnCalculationProto_AnalysisColumnsMap.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.reference_column_ids) {
      writer.uint32(18).string(v!);
    }
    if (message.diagnostic_rules !== undefined) {
      DiagnosticResultRules.encode(message.diagnostic_rules, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisColumnCalculationProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisColumnCalculationProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.analysis_columns_map.push(
            AnalysisColumnCalculationProto_AnalysisColumnsMap.decode(reader, reader.uint32()),
          );
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reference_column_ids.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.diagnostic_rules = DiagnosticResultRules.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisColumnCalculationProto {
    return {
      analysis_columns_map: globalThis.Array.isArray(object?.analysis_columns_map)
        ? object.analysis_columns_map.map((e: any) => AnalysisColumnCalculationProto_AnalysisColumnsMap.fromJSON(e))
        : [],
      reference_column_ids: globalThis.Array.isArray(object?.reference_column_ids)
        ? object.reference_column_ids.map((e: any) => globalThis.String(e))
        : [],
      diagnostic_rules: isSet(object.diagnostic_rules)
        ? DiagnosticResultRules.fromJSON(object.diagnostic_rules)
        : undefined,
    };
  },

  toJSON(message: AnalysisColumnCalculationProto): unknown {
    const obj: any = {};
    if (message.analysis_columns_map?.length) {
      obj.analysis_columns_map = message.analysis_columns_map.map((e) =>
        AnalysisColumnCalculationProto_AnalysisColumnsMap.toJSON(e)
      );
    }
    if (message.reference_column_ids?.length) {
      obj.reference_column_ids = message.reference_column_ids;
    }
    if (message.diagnostic_rules !== undefined) {
      obj.diagnostic_rules = DiagnosticResultRules.toJSON(message.diagnostic_rules);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisColumnCalculationProto>, I>>(base?: I): AnalysisColumnCalculationProto {
    return AnalysisColumnCalculationProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisColumnCalculationProto>, I>>(
    object: I,
  ): AnalysisColumnCalculationProto {
    const message = createBaseAnalysisColumnCalculationProto();
    message.analysis_columns_map =
      object.analysis_columns_map?.map((e) => AnalysisColumnCalculationProto_AnalysisColumnsMap.fromPartial(e)) || [];
    message.reference_column_ids = object.reference_column_ids?.map((e) => e) || [];
    message.diagnostic_rules = (object.diagnostic_rules !== undefined && object.diagnostic_rules !== null)
      ? DiagnosticResultRules.fromPartial(object.diagnostic_rules)
      : undefined;
    return message;
  },
};

function createBaseAnalysisColumnCalculationProto_AnalysisColumnsMap(): AnalysisColumnCalculationProto_AnalysisColumnsMap {
  return { column_id: undefined, column_type: undefined };
}

export const AnalysisColumnCalculationProto_AnalysisColumnsMap: MessageFns<
  AnalysisColumnCalculationProto_AnalysisColumnsMap
> = {
  encode(
    message: AnalysisColumnCalculationProto_AnalysisColumnsMap,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.column_id !== undefined) {
      writer.uint32(10).string(message.column_id);
    }
    if (message.column_type !== undefined) {
      writer.uint32(16).int32(message.column_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisColumnCalculationProto_AnalysisColumnsMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisColumnCalculationProto_AnalysisColumnsMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.column_type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisColumnCalculationProto_AnalysisColumnsMap {
    return {
      column_id: isSet(object.column_id) ? globalThis.String(object.column_id) : undefined,
      column_type: isSet(object.column_type) ? analysisColumnTypeFromJSON(object.column_type) : undefined,
    };
  },

  toJSON(message: AnalysisColumnCalculationProto_AnalysisColumnsMap): unknown {
    const obj: any = {};
    if (message.column_id !== undefined) {
      obj.column_id = message.column_id;
    }
    if (message.column_type !== undefined) {
      obj.column_type = analysisColumnTypeToJSON(message.column_type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisColumnCalculationProto_AnalysisColumnsMap>, I>>(
    base?: I,
  ): AnalysisColumnCalculationProto_AnalysisColumnsMap {
    return AnalysisColumnCalculationProto_AnalysisColumnsMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisColumnCalculationProto_AnalysisColumnsMap>, I>>(
    object: I,
  ): AnalysisColumnCalculationProto_AnalysisColumnsMap {
    const message = createBaseAnalysisColumnCalculationProto_AnalysisColumnsMap();
    message.column_id = object.column_id ?? undefined;
    message.column_type = object.column_type ?? undefined;
    return message;
  },
};

function createBaseRecommendationRuleProto(): RecommendationRuleProto {
  return { selections: [], child_step_ids: [] };
}

export const RecommendationRuleProto: MessageFns<RecommendationRuleProto> = {
  encode(message: RecommendationRuleProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.selections) {
      SelectionCriteriaProto.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.child_step_ids) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecommendationRuleProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecommendationRuleProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.selections.push(SelectionCriteriaProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.child_step_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecommendationRuleProto {
    return {
      selections: globalThis.Array.isArray(object?.selections)
        ? object.selections.map((e: any) => SelectionCriteriaProto.fromJSON(e))
        : [],
      child_step_ids: globalThis.Array.isArray(object?.child_step_ids)
        ? object.child_step_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: RecommendationRuleProto): unknown {
    const obj: any = {};
    if (message.selections?.length) {
      obj.selections = message.selections.map((e) => SelectionCriteriaProto.toJSON(e));
    }
    if (message.child_step_ids?.length) {
      obj.child_step_ids = message.child_step_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecommendationRuleProto>, I>>(base?: I): RecommendationRuleProto {
    return RecommendationRuleProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecommendationRuleProto>, I>>(object: I): RecommendationRuleProto {
    const message = createBaseRecommendationRuleProto();
    message.selections = object.selections?.map((e) => SelectionCriteriaProto.fromPartial(e)) || [];
    message.child_step_ids = object.child_step_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseSelectionCriteriaProto(): SelectionCriteriaProto {
  return {
    type: undefined,
    attribute_values_map: [],
    criteria_columns: [],
    criteria_column_id: undefined,
    specific_values: [],
    rows_subset: undefined,
    threshold: undefined,
  };
}

export const SelectionCriteriaProto: MessageFns<SelectionCriteriaProto> = {
  encode(message: SelectionCriteriaProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    for (const v of message.attribute_values_map) {
      SelectionCriteriaProto_AttributeValues.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.criteria_columns) {
      ColumnHashProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.criteria_column_id !== undefined) {
      writer.uint32(42).string(message.criteria_column_id);
    }
    for (const v of message.specific_values) {
      writer.uint32(50).string(v!);
    }
    if (message.rows_subset !== undefined) {
      SelectionCriteriaProto_RowsSubset.encode(message.rows_subset, writer.uint32(58).fork()).join();
    }
    if (message.threshold !== undefined) {
      writer.uint32(65).double(message.threshold);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectionCriteriaProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectionCriteriaProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attribute_values_map.push(SelectionCriteriaProto_AttributeValues.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.criteria_columns.push(ColumnHashProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.criteria_column_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.specific_values.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rows_subset = SelectionCriteriaProto_RowsSubset.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.threshold = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectionCriteriaProto {
    return {
      type: isSet(object.type) ? selectionTypeFromJSON(object.type) : undefined,
      attribute_values_map: globalThis.Array.isArray(object?.attribute_values_map)
        ? object.attribute_values_map.map((e: any) => SelectionCriteriaProto_AttributeValues.fromJSON(e))
        : [],
      criteria_columns: globalThis.Array.isArray(object?.criteria_columns)
        ? object.criteria_columns.map((e: any) => ColumnHashProto.fromJSON(e))
        : [],
      criteria_column_id: isSet(object.criteria_column_id) ? globalThis.String(object.criteria_column_id) : undefined,
      specific_values: globalThis.Array.isArray(object?.specific_values)
        ? object.specific_values.map((e: any) => globalThis.String(e))
        : [],
      rows_subset: isSet(object.rows_subset)
        ? SelectionCriteriaProto_RowsSubset.fromJSON(object.rows_subset)
        : undefined,
      threshold: isSet(object.threshold) ? globalThis.Number(object.threshold) : undefined,
    };
  },

  toJSON(message: SelectionCriteriaProto): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = selectionTypeToJSON(message.type);
    }
    if (message.attribute_values_map?.length) {
      obj.attribute_values_map = message.attribute_values_map.map((e) =>
        SelectionCriteriaProto_AttributeValues.toJSON(e)
      );
    }
    if (message.criteria_columns?.length) {
      obj.criteria_columns = message.criteria_columns.map((e) => ColumnHashProto.toJSON(e));
    }
    if (message.criteria_column_id !== undefined) {
      obj.criteria_column_id = message.criteria_column_id;
    }
    if (message.specific_values?.length) {
      obj.specific_values = message.specific_values;
    }
    if (message.rows_subset !== undefined) {
      obj.rows_subset = SelectionCriteriaProto_RowsSubset.toJSON(message.rows_subset);
    }
    if (message.threshold !== undefined) {
      obj.threshold = message.threshold;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectionCriteriaProto>, I>>(base?: I): SelectionCriteriaProto {
    return SelectionCriteriaProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectionCriteriaProto>, I>>(object: I): SelectionCriteriaProto {
    const message = createBaseSelectionCriteriaProto();
    message.type = object.type ?? undefined;
    message.attribute_values_map =
      object.attribute_values_map?.map((e) => SelectionCriteriaProto_AttributeValues.fromPartial(e)) || [];
    message.criteria_columns = object.criteria_columns?.map((e) => ColumnHashProto.fromPartial(e)) || [];
    message.criteria_column_id = object.criteria_column_id ?? undefined;
    message.specific_values = object.specific_values?.map((e) => e) || [];
    message.rows_subset = (object.rows_subset !== undefined && object.rows_subset !== null)
      ? SelectionCriteriaProto_RowsSubset.fromPartial(object.rows_subset)
      : undefined;
    message.threshold = object.threshold ?? undefined;
    return message;
  },
};

function createBaseSelectionCriteriaProto_AttributeValues(): SelectionCriteriaProto_AttributeValues {
  return { column_id: undefined, values: [] };
}

export const SelectionCriteriaProto_AttributeValues: MessageFns<SelectionCriteriaProto_AttributeValues> = {
  encode(message: SelectionCriteriaProto_AttributeValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_id !== undefined) {
      writer.uint32(10).string(message.column_id);
    }
    for (const v of message.values) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectionCriteriaProto_AttributeValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectionCriteriaProto_AttributeValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectionCriteriaProto_AttributeValues {
    return {
      column_id: isSet(object.column_id) ? globalThis.String(object.column_id) : undefined,
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: SelectionCriteriaProto_AttributeValues): unknown {
    const obj: any = {};
    if (message.column_id !== undefined) {
      obj.column_id = message.column_id;
    }
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectionCriteriaProto_AttributeValues>, I>>(
    base?: I,
  ): SelectionCriteriaProto_AttributeValues {
    return SelectionCriteriaProto_AttributeValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectionCriteriaProto_AttributeValues>, I>>(
    object: I,
  ): SelectionCriteriaProto_AttributeValues {
    const message = createBaseSelectionCriteriaProto_AttributeValues();
    message.column_id = object.column_id ?? undefined;
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseSelectionCriteriaProto_RowsSubset(): SelectionCriteriaProto_RowsSubset {
  return { reference_id: undefined, row_values: [] };
}

export const SelectionCriteriaProto_RowsSubset: MessageFns<SelectionCriteriaProto_RowsSubset> = {
  encode(message: SelectionCriteriaProto_RowsSubset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reference_id !== undefined) {
      writer.uint32(10).string(message.reference_id);
    }
    for (const v of message.row_values) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectionCriteriaProto_RowsSubset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectionCriteriaProto_RowsSubset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reference_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.row_values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectionCriteriaProto_RowsSubset {
    return {
      reference_id: isSet(object.reference_id) ? globalThis.String(object.reference_id) : undefined,
      row_values: globalThis.Array.isArray(object?.row_values)
        ? object.row_values.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SelectionCriteriaProto_RowsSubset): unknown {
    const obj: any = {};
    if (message.reference_id !== undefined) {
      obj.reference_id = message.reference_id;
    }
    if (message.row_values?.length) {
      obj.row_values = message.row_values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectionCriteriaProto_RowsSubset>, I>>(
    base?: I,
  ): SelectionCriteriaProto_RowsSubset {
    return SelectionCriteriaProto_RowsSubset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectionCriteriaProto_RowsSubset>, I>>(
    object: I,
  ): SelectionCriteriaProto_RowsSubset {
    const message = createBaseSelectionCriteriaProto_RowsSubset();
    message.reference_id = object.reference_id ?? undefined;
    message.row_values = object.row_values?.map((e) => e) || [];
    return message;
  },
};

function createBaseDataResultRowProto(): DataResultRowProto {
  return { row_index: undefined, column_values: [] };
}

export const DataResultRowProto: MessageFns<DataResultRowProto> = {
  encode(message: DataResultRowProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.row_index !== undefined) {
      writer.uint32(8).int32(message.row_index);
    }
    for (const v of message.column_values) {
      DataResultRowProto_ColumnValue.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataResultRowProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataResultRowProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.row_index = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.column_values.push(DataResultRowProto_ColumnValue.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataResultRowProto {
    return {
      row_index: isSet(object.row_index) ? globalThis.Number(object.row_index) : undefined,
      column_values: globalThis.Array.isArray(object?.column_values)
        ? object.column_values.map((e: any) => DataResultRowProto_ColumnValue.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DataResultRowProto): unknown {
    const obj: any = {};
    if (message.row_index !== undefined) {
      obj.row_index = Math.round(message.row_index);
    }
    if (message.column_values?.length) {
      obj.column_values = message.column_values.map((e) => DataResultRowProto_ColumnValue.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataResultRowProto>, I>>(base?: I): DataResultRowProto {
    return DataResultRowProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataResultRowProto>, I>>(object: I): DataResultRowProto {
    const message = createBaseDataResultRowProto();
    message.row_index = object.row_index ?? undefined;
    message.column_values = object.column_values?.map((e) => DataResultRowProto_ColumnValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDataResultRowProto_ColumnValue(): DataResultRowProto_ColumnValue {
  return { column_id: undefined, value: undefined };
}

export const DataResultRowProto_ColumnValue: MessageFns<DataResultRowProto_ColumnValue> = {
  encode(message: DataResultRowProto_ColumnValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_id !== undefined) {
      writer.uint32(10).string(message.column_id);
    }
    if (message.value !== undefined) {
      DataValueProto.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataResultRowProto_ColumnValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataResultRowProto_ColumnValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = DataValueProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataResultRowProto_ColumnValue {
    return {
      column_id: isSet(object.column_id) ? globalThis.String(object.column_id) : undefined,
      value: isSet(object.value) ? DataValueProto.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: DataResultRowProto_ColumnValue): unknown {
    const obj: any = {};
    if (message.column_id !== undefined) {
      obj.column_id = message.column_id;
    }
    if (message.value !== undefined) {
      obj.value = DataValueProto.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataResultRowProto_ColumnValue>, I>>(base?: I): DataResultRowProto_ColumnValue {
    return DataResultRowProto_ColumnValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataResultRowProto_ColumnValue>, I>>(
    object: I,
  ): DataResultRowProto_ColumnValue {
    const message = createBaseDataResultRowProto_ColumnValue();
    message.column_id = object.column_id ?? undefined;
    message.value = (object.value !== undefined && object.value !== null)
      ? DataValueProto.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseNodeResultProto(): NodeResultProto {
  return { data_results: [], mixture_profile: undefined, num_rows: undefined, node_failures: [], error_details: [] };
}

export const NodeResultProto: MessageFns<NodeResultProto> = {
  encode(message: NodeResultProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.data_results) {
      DataResultRowProto.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.mixture_profile !== undefined) {
      writer.uint32(16).int32(message.mixture_profile);
    }
    if (message.num_rows !== undefined) {
      writer.uint32(24).int32(message.num_rows);
    }
    for (const v of message.node_failures) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.error_details) {
      ErrorDetailProto.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeResultProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeResultProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data_results.push(DataResultRowProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mixture_profile = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.num_rows = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.node_failures.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.error_details.push(ErrorDetailProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodeResultProto {
    return {
      data_results: globalThis.Array.isArray(object?.data_results)
        ? object.data_results.map((e: any) => DataResultRowProto.fromJSON(e))
        : [],
      mixture_profile: isSet(object.mixture_profile) ? outcomeMixtureFromJSON(object.mixture_profile) : undefined,
      num_rows: isSet(object.num_rows) ? globalThis.Number(object.num_rows) : undefined,
      node_failures: globalThis.Array.isArray(object?.node_failures)
        ? object.node_failures.map((e: any) => globalThis.String(e))
        : [],
      error_details: globalThis.Array.isArray(object?.error_details)
        ? object.error_details.map((e: any) => ErrorDetailProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: NodeResultProto): unknown {
    const obj: any = {};
    if (message.data_results?.length) {
      obj.data_results = message.data_results.map((e) => DataResultRowProto.toJSON(e));
    }
    if (message.mixture_profile !== undefined) {
      obj.mixture_profile = outcomeMixtureToJSON(message.mixture_profile);
    }
    if (message.num_rows !== undefined) {
      obj.num_rows = Math.round(message.num_rows);
    }
    if (message.node_failures?.length) {
      obj.node_failures = message.node_failures;
    }
    if (message.error_details?.length) {
      obj.error_details = message.error_details.map((e) => ErrorDetailProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeResultProto>, I>>(base?: I): NodeResultProto {
    return NodeResultProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeResultProto>, I>>(object: I): NodeResultProto {
    const message = createBaseNodeResultProto();
    message.data_results = object.data_results?.map((e) => DataResultRowProto.fromPartial(e)) || [];
    message.mixture_profile = object.mixture_profile ?? undefined;
    message.num_rows = object.num_rows ?? undefined;
    message.node_failures = object.node_failures?.map((e) => e) || [];
    message.error_details = object.error_details?.map((e) => ErrorDetailProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTreeNodeProto(): TreeNodeProto {
  return {
    id: undefined,
    observation: undefined,
    node_depth: undefined,
    metric: undefined,
    edges: [],
    analysed_data: undefined,
    analysis_result: undefined,
    children_ids: [],
    parent_reference: undefined,
  };
}

export const TreeNodeProto: MessageFns<TreeNodeProto> = {
  encode(message: TreeNodeProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.observation !== undefined) {
      ObservationProto.encode(message.observation, writer.uint32(18).fork()).join();
    }
    if (message.node_depth !== undefined) {
      writer.uint32(24).int32(message.node_depth);
    }
    if (message.metric !== undefined) {
      MetricProto.encode(message.metric, writer.uint32(34).fork()).join();
    }
    for (const v of message.edges) {
      MetricEdgeProto.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.analysed_data !== undefined) {
      ObservationDataProto.encode(message.analysed_data, writer.uint32(50).fork()).join();
    }
    if (message.analysis_result !== undefined) {
      NodeResultProto.encode(message.analysis_result, writer.uint32(58).fork()).join();
    }
    for (const v of message.children_ids) {
      writer.uint32(66).string(v!);
    }
    if (message.parent_reference !== undefined) {
      TreeNodeProto_ParentReference.encode(message.parent_reference, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNodeProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTreeNodeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.observation = ObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.node_depth = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metric = MetricProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.edges.push(MetricEdgeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.analysed_data = ObservationDataProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.analysis_result = NodeResultProto.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.children_ids.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.parent_reference = TreeNodeProto_ParentReference.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TreeNodeProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      observation: isSet(object.observation) ? ObservationProto.fromJSON(object.observation) : undefined,
      node_depth: isSet(object.node_depth) ? globalThis.Number(object.node_depth) : undefined,
      metric: isSet(object.metric) ? MetricProto.fromJSON(object.metric) : undefined,
      edges: globalThis.Array.isArray(object?.edges) ? object.edges.map((e: any) => MetricEdgeProto.fromJSON(e)) : [],
      analysed_data: isSet(object.analysed_data) ? ObservationDataProto.fromJSON(object.analysed_data) : undefined,
      analysis_result: isSet(object.analysis_result) ? NodeResultProto.fromJSON(object.analysis_result) : undefined,
      children_ids: globalThis.Array.isArray(object?.children_ids)
        ? object.children_ids.map((e: any) => globalThis.String(e))
        : [],
      parent_reference: isSet(object.parent_reference)
        ? TreeNodeProto_ParentReference.fromJSON(object.parent_reference)
        : undefined,
    };
  },

  toJSON(message: TreeNodeProto): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.observation !== undefined) {
      obj.observation = ObservationProto.toJSON(message.observation);
    }
    if (message.node_depth !== undefined) {
      obj.node_depth = Math.round(message.node_depth);
    }
    if (message.metric !== undefined) {
      obj.metric = MetricProto.toJSON(message.metric);
    }
    if (message.edges?.length) {
      obj.edges = message.edges.map((e) => MetricEdgeProto.toJSON(e));
    }
    if (message.analysed_data !== undefined) {
      obj.analysed_data = ObservationDataProto.toJSON(message.analysed_data);
    }
    if (message.analysis_result !== undefined) {
      obj.analysis_result = NodeResultProto.toJSON(message.analysis_result);
    }
    if (message.children_ids?.length) {
      obj.children_ids = message.children_ids;
    }
    if (message.parent_reference !== undefined) {
      obj.parent_reference = TreeNodeProto_ParentReference.toJSON(message.parent_reference);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TreeNodeProto>, I>>(base?: I): TreeNodeProto {
    return TreeNodeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TreeNodeProto>, I>>(object: I): TreeNodeProto {
    const message = createBaseTreeNodeProto();
    message.id = object.id ?? undefined;
    message.observation = (object.observation !== undefined && object.observation !== null)
      ? ObservationProto.fromPartial(object.observation)
      : undefined;
    message.node_depth = object.node_depth ?? undefined;
    message.metric = (object.metric !== undefined && object.metric !== null)
      ? MetricProto.fromPartial(object.metric)
      : undefined;
    message.edges = object.edges?.map((e) => MetricEdgeProto.fromPartial(e)) || [];
    message.analysed_data = (object.analysed_data !== undefined && object.analysed_data !== null)
      ? ObservationDataProto.fromPartial(object.analysed_data)
      : undefined;
    message.analysis_result = (object.analysis_result !== undefined && object.analysis_result !== null)
      ? NodeResultProto.fromPartial(object.analysis_result)
      : undefined;
    message.children_ids = object.children_ids?.map((e) => e) || [];
    message.parent_reference = (object.parent_reference !== undefined && object.parent_reference !== null)
      ? TreeNodeProto_ParentReference.fromPartial(object.parent_reference)
      : undefined;
    return message;
  },
};

function createBaseTreeNodeProto_ParentReference(): TreeNodeProto_ParentReference {
  return { parent_id: undefined, row_index: undefined };
}

export const TreeNodeProto_ParentReference: MessageFns<TreeNodeProto_ParentReference> = {
  encode(message: TreeNodeProto_ParentReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parent_id !== undefined) {
      writer.uint32(10).string(message.parent_id);
    }
    if (message.row_index !== undefined) {
      writer.uint32(16).int32(message.row_index);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNodeProto_ParentReference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTreeNodeProto_ParentReference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.parent_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.row_index = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TreeNodeProto_ParentReference {
    return {
      parent_id: isSet(object.parent_id) ? globalThis.String(object.parent_id) : undefined,
      row_index: isSet(object.row_index) ? globalThis.Number(object.row_index) : undefined,
    };
  },

  toJSON(message: TreeNodeProto_ParentReference): unknown {
    const obj: any = {};
    if (message.parent_id !== undefined) {
      obj.parent_id = message.parent_id;
    }
    if (message.row_index !== undefined) {
      obj.row_index = Math.round(message.row_index);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TreeNodeProto_ParentReference>, I>>(base?: I): TreeNodeProto_ParentReference {
    return TreeNodeProto_ParentReference.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TreeNodeProto_ParentReference>, I>>(
    object: I,
  ): TreeNodeProto_ParentReference {
    const message = createBaseTreeNodeProto_ParentReference();
    message.parent_id = object.parent_id ?? undefined;
    message.row_index = object.row_index ?? undefined;
    return message;
  },
};

function createBaseKGObservationProto(): KGObservationProto {
  return {
    metrics: [],
    benchmarks: [],
    columns: [],
    filters: [],
    skipped_metric_ids: [],
    calculate_non_measure_only: undefined,
    benchmark_columns: [],
    analysis_columns: [],
  };
}

export const KGObservationProto: MessageFns<KGObservationProto> = {
  encode(message: KGObservationProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.metrics) {
      MetricProto.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.benchmarks) {
      BenchmarkEntityProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.columns) {
      ObservationColumnProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.filters) {
      FilterProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.skipped_metric_ids) {
      writer.uint32(42).string(v!);
    }
    if (message.calculate_non_measure_only !== undefined) {
      writer.uint32(48).bool(message.calculate_non_measure_only);
    }
    for (const v of message.benchmark_columns) {
      ColumnHashProto.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.analysis_columns) {
      ColumnHashProto.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGObservationProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGObservationProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metrics.push(MetricProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.benchmarks.push(BenchmarkEntityProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.columns.push(ObservationColumnProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.filters.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.skipped_metric_ids.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.calculate_non_measure_only = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.benchmark_columns.push(ColumnHashProto.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.analysis_columns.push(ColumnHashProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGObservationProto {
    return {
      metrics: globalThis.Array.isArray(object?.metrics) ? object.metrics.map((e: any) => MetricProto.fromJSON(e)) : [],
      benchmarks: globalThis.Array.isArray(object?.benchmarks)
        ? object.benchmarks.map((e: any) => BenchmarkEntityProto.fromJSON(e))
        : [],
      columns: globalThis.Array.isArray(object?.columns)
        ? object.columns.map((e: any) => ObservationColumnProto.fromJSON(e))
        : [],
      filters: globalThis.Array.isArray(object?.filters) ? object.filters.map((e: any) => FilterProto.fromJSON(e)) : [],
      skipped_metric_ids: globalThis.Array.isArray(object?.skipped_metric_ids)
        ? object.skipped_metric_ids.map((e: any) => globalThis.String(e))
        : [],
      calculate_non_measure_only: isSet(object.calculate_non_measure_only)
        ? globalThis.Boolean(object.calculate_non_measure_only)
        : undefined,
      benchmark_columns: globalThis.Array.isArray(object?.benchmark_columns)
        ? object.benchmark_columns.map((e: any) => ColumnHashProto.fromJSON(e))
        : [],
      analysis_columns: globalThis.Array.isArray(object?.analysis_columns)
        ? object.analysis_columns.map((e: any) => ColumnHashProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: KGObservationProto): unknown {
    const obj: any = {};
    if (message.metrics?.length) {
      obj.metrics = message.metrics.map((e) => MetricProto.toJSON(e));
    }
    if (message.benchmarks?.length) {
      obj.benchmarks = message.benchmarks.map((e) => BenchmarkEntityProto.toJSON(e));
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => ObservationColumnProto.toJSON(e));
    }
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => FilterProto.toJSON(e));
    }
    if (message.skipped_metric_ids?.length) {
      obj.skipped_metric_ids = message.skipped_metric_ids;
    }
    if (message.calculate_non_measure_only !== undefined) {
      obj.calculate_non_measure_only = message.calculate_non_measure_only;
    }
    if (message.benchmark_columns?.length) {
      obj.benchmark_columns = message.benchmark_columns.map((e) => ColumnHashProto.toJSON(e));
    }
    if (message.analysis_columns?.length) {
      obj.analysis_columns = message.analysis_columns.map((e) => ColumnHashProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGObservationProto>, I>>(base?: I): KGObservationProto {
    return KGObservationProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGObservationProto>, I>>(object: I): KGObservationProto {
    const message = createBaseKGObservationProto();
    message.metrics = object.metrics?.map((e) => MetricProto.fromPartial(e)) || [];
    message.benchmarks = object.benchmarks?.map((e) => BenchmarkEntityProto.fromPartial(e)) || [];
    message.columns = object.columns?.map((e) => ObservationColumnProto.fromPartial(e)) || [];
    message.filters = object.filters?.map((e) => FilterProto.fromPartial(e)) || [];
    message.skipped_metric_ids = object.skipped_metric_ids?.map((e) => e) || [];
    message.calculate_non_measure_only = object.calculate_non_measure_only ?? undefined;
    message.benchmark_columns = object.benchmark_columns?.map((e) => ColumnHashProto.fromPartial(e)) || [];
    message.analysis_columns = object.analysis_columns?.map((e) => ColumnHashProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseKGObservationDataProto(): KGObservationDataProto {
  return {
    kg_observation: undefined,
    actuals: [],
    benchmark_values: [],
    non_measure_values: [],
    analysis_columns: [],
    material_columns: [],
    missing_columns: [],
  };
}

export const KGObservationDataProto: MessageFns<KGObservationDataProto> = {
  encode(message: KGObservationDataProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(10).fork()).join();
    }
    for (const v of message.actuals) {
      ColumnValuesProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.benchmark_values) {
      ColumnValuesProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.non_measure_values) {
      ColumnValuesProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.analysis_columns) {
      ColumnValuesProto.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.material_columns) {
      ColumnValuesProto.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.missing_columns) {
      ColumnHashProto.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGObservationDataProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGObservationDataProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.actuals.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.benchmark_values.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.non_measure_values.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.analysis_columns.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.material_columns.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.missing_columns.push(ColumnHashProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGObservationDataProto {
    return {
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      actuals: globalThis.Array.isArray(object?.actuals)
        ? object.actuals.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      benchmark_values: globalThis.Array.isArray(object?.benchmark_values)
        ? object.benchmark_values.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      non_measure_values: globalThis.Array.isArray(object?.non_measure_values)
        ? object.non_measure_values.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      analysis_columns: globalThis.Array.isArray(object?.analysis_columns)
        ? object.analysis_columns.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      material_columns: globalThis.Array.isArray(object?.material_columns)
        ? object.material_columns.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      missing_columns: globalThis.Array.isArray(object?.missing_columns)
        ? object.missing_columns.map((e: any) => ColumnHashProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: KGObservationDataProto): unknown {
    const obj: any = {};
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.actuals?.length) {
      obj.actuals = message.actuals.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.benchmark_values?.length) {
      obj.benchmark_values = message.benchmark_values.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.non_measure_values?.length) {
      obj.non_measure_values = message.non_measure_values.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.analysis_columns?.length) {
      obj.analysis_columns = message.analysis_columns.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.material_columns?.length) {
      obj.material_columns = message.material_columns.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.missing_columns?.length) {
      obj.missing_columns = message.missing_columns.map((e) => ColumnHashProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGObservationDataProto>, I>>(base?: I): KGObservationDataProto {
    return KGObservationDataProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGObservationDataProto>, I>>(object: I): KGObservationDataProto {
    const message = createBaseKGObservationDataProto();
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.actuals = object.actuals?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.benchmark_values = object.benchmark_values?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.non_measure_values = object.non_measure_values?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.analysis_columns = object.analysis_columns?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.material_columns = object.material_columns?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.missing_columns = object.missing_columns?.map((e) => ColumnHashProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRecommendationProto(): RecommendationProto {
  return { id: undefined, edits: [], recommended_data: [], select_anyone: [], parent_kg_observation: undefined };
}

export const RecommendationProto: MessageFns<RecommendationProto> = {
  encode(message: RecommendationProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.edits) {
      ObservationEditProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.recommended_data) {
      ColumnValuesProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.select_anyone) {
      writer.uint32(34).string(v!);
    }
    if (message.parent_kg_observation !== undefined) {
      KGObservationProto.encode(message.parent_kg_observation, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecommendationProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecommendationProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.edits.push(ObservationEditProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recommended_data.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.select_anyone.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parent_kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecommendationProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      edits: globalThis.Array.isArray(object?.edits)
        ? object.edits.map((e: any) => ObservationEditProto.fromJSON(e))
        : [],
      recommended_data: globalThis.Array.isArray(object?.recommended_data)
        ? object.recommended_data.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      select_anyone: globalThis.Array.isArray(object?.select_anyone)
        ? object.select_anyone.map((e: any) => globalThis.String(e))
        : [],
      parent_kg_observation: isSet(object.parent_kg_observation)
        ? KGObservationProto.fromJSON(object.parent_kg_observation)
        : undefined,
    };
  },

  toJSON(message: RecommendationProto): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.edits?.length) {
      obj.edits = message.edits.map((e) => ObservationEditProto.toJSON(e));
    }
    if (message.recommended_data?.length) {
      obj.recommended_data = message.recommended_data.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.select_anyone?.length) {
      obj.select_anyone = message.select_anyone;
    }
    if (message.parent_kg_observation !== undefined) {
      obj.parent_kg_observation = KGObservationProto.toJSON(message.parent_kg_observation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecommendationProto>, I>>(base?: I): RecommendationProto {
    return RecommendationProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecommendationProto>, I>>(object: I): RecommendationProto {
    const message = createBaseRecommendationProto();
    message.id = object.id ?? undefined;
    message.edits = object.edits?.map((e) => ObservationEditProto.fromPartial(e)) || [];
    message.recommended_data = object.recommended_data?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.select_anyone = object.select_anyone?.map((e) => e) || [];
    message.parent_kg_observation =
      (object.parent_kg_observation !== undefined && object.parent_kg_observation !== null)
        ? KGObservationProto.fromPartial(object.parent_kg_observation)
        : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
